const removeLabelStyle = (content)=>{//去除标签内部所有的样式
    if(!content){
        return content;
    }
    return content.replace(/<([a-zA-Z\/]*)[^>]*>/g, function(label,labelName){
        if([ 'a' , 'A',
            "img", "IMG" ,
            "iframe" ,"IFRAME",
            "table" ,"TABLE",
            "tbody" ,"TBODY",
            "thead" ,"THEAD",
            "th" ,"TH",
            "tr" ,"TR",
            "td" ,"TD",
            "tfoot" ,"TFOOT",
        ].indexOf(labelName) > -1){
            return label;
        }
        return `<${labelName}>`;
    });
};
export default removeLabelStyle;